module.exports = __webpack_public_path__ + "img/placeholder.76dc311a.gif";